import {compose, map, glue, pairs} from 'app/utils/f'

export const getBaseUrl = url => {
    if(!url) return ''
    if(url.indexOf('?') === -1 && url.indexOf('#') === -1) return ''

    return url.replace(/[?#].*?$/, '')
}

// e.g. ? or #
export const getParamChar = url => {
    if(!url) return ''

    return url.indexOf('?') !== -1
        ? '?'
        : url.indexOf('#') !== -1
            ? '?'
            : ''
}

export const getParams = url => {
    if(!url) return {}
    if(url.indexOf('?') === -1 && url.indexOf('#') === -1) return {}

    return url.replace(/^.*?[?#]/, '')
        .split('&')
        .reduce((acc, param) => {
            const [key, value] = param.split('=')
            const valueDecoded = decodeURIComponent(value).replace(/\+/g, ' ')

            if(acc.hasOwnProperty(key)) {
                if(Array.isArray(acc[key])) {
                    acc[key] = acc[key].concat([valueDecoded])
                }
                else {
                    acc[key] = [acc[key], valueDecoded]
                }
            }
            else {
                acc[key] = valueDecoded
            }

            return acc
        }, {})
}

export function getUrlParam(name, defaultValue = null) {
    const url = window.location.href
    const namePrepared = name.replace(/[\[\]]/g, '\\$&') // eslint-disable-line no-useless-escape
    const regex = new RegExp('[#?&]' + namePrepared + '(=([^&#]*)|&|#|$)')
    const results = regex.exec(url)

    return results && results[2]
        ? decodeURIComponent(results[2].replace(/\+/g, ' '))
        : defaultValue
}

export function getUrlParamBase64Encoded(name, defaultValue = null) {
    const value = getUrlParam(name, defaultValue)
    if(value === defaultValue) return value

    return atob(value)
}

export function getCurrentBaseUrl() {
    return window.location.origin + window.location.pathname;
}

export function paramsToUrl(baseUrl, params) {
    return (baseUrl.indexOf('?') === -1 ? baseUrl + '?' : baseUrl + '&') + Object.keys(params).map((k) => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&')
}



// WEBPACK FOOTER //
// ./react/utils/url.js